import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  getMessageMinimumDetailsAction,
  getRecipientAction,
  getRecipientEventsClicksAction,
} from '../actions/actions'

import { pageState } from 'State/page'

import {
  recipientState,
  tableLoadingState,
  tableStateResult,
  tableStateSerach,
} from '../state/result'

// import {
//   storeGet
// } from 'mailup-react-helpers'

export const loadClickDetailsCallback =
  ({ set }) =>
  async (Clicks) => {
    if (Clicks.TotalItems > 0) {
      Clicks.EventList.forEach(async (r, index) => {
        const messageDetails = await getMessageMinimumDetailsAction(r.IdMessage)
        if (r.IdMessage) {
          set(tableStateResult, (prev) => ({
            ...prev,
            items: prev.items.map((m) =>
              m.IdMessage === r.IdMessage
                ? {
                    ...m,
                    Subject: messageDetails.Subject,
                    Tag: messageDetails.Tag,
                    Note: messageDetails.Note
                      ? 'ID ' + r.IdMessage + ' - ' + messageDetails.Note
                      : 'ID ' + r.IdMessage,
                  }
                : m,
            ),
          }))
        } else {
          set(tableStateResult, (prev) => ({
            ...prev,
            items: prev.items.map((m) =>
              m.IdMessage === r.IdMessage
                ? {
                    ...m,
                    Subject: '-',
                  }
                : m,
            ),
          }))
        }
      })
    }
  }

export const getRecipientCallback =
  ({ set, snapshot, reset }) =>
  async (idRecipient) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
    }))

    const { pageSize, pageNumber, orderBy, orderDescending } =
      await snapshot.getPromise(tableStateSerach)

    try {
      const resp = await getRecipientAction(idRecipient)

      const clicks = await getRecipientEventsClicksAction(
        idRecipient,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending,
      )

      set(recipientState, (prev) => ({
        ...prev,
        recipientProfile: resp,
        loaded: true,
        channel: resp.Email ? 'email' : 'sms',
      }))

      set(tableStateResult, (prev) => ({
        ...prev,
        items: clicks.Clicks.EventList.filter((f) => f.IdMessage > 0),
        totalItems: clicks.Clicks.TotalItems,
      }))

      set(tableLoadingState, false)

      loadClickDetailsCallback({ set })(clicks.Clicks)

      set(pageState, (prev) => ({
        ...prev,
        status: 'ready',
      }))
    } catch (error) {
      logAppError({ appError: error })

      set(pageState, (prev) => ({
        ...prev,
        status: 'error',
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
    }))
  }

export const laodClickTableCallback =
  ({ set, snapshot, reset }) =>
  async ({ idRecipient, pageNumber, pageSize, orderBy, orderDescending }) => {
    set(tableLoadingState, true)

    try {
      const search = await snapshot.getPromise(tableStateSerach)

      const searchParams = {
        ...search,
        pageNumber: pageNumber || search.pageNumber,
        pageSize: pageSize || search.pageSize,
        orderDescending:
          orderBy === search.orderBy
            ? !search.orderDescending
            : search.orderDescending,
        orderBy: orderBy || search.orderBy,
      }

      const resp = await getRecipientEventsClicksAction(
        idRecipient,
        searchParams.pageSize,
        searchParams.pageNumber,
        searchParams.orderBy,
        searchParams.orderDescending,
      )

      set(tableStateResult, (prev) => ({
        ...prev,
        items: resp.Clicks.EventList.filter((f) => f.IdMessage > 0),
        totalItems: resp.Clicks.TotalItems,
      }))

      //
      loadClickDetailsCallback({ set })(resp.Clicks)
      //
      set(tableStateSerach, searchParams)
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        status: 'error',
      })
    }

    set(tableLoadingState, false)
  }

export const resetPageCallback =
  ({ reset }) =>
  async () => {
    reset(pageState)

    reset(recipientState)
    reset(tableLoadingState)
    reset(tableStateResult)
    reset(tableStateSerach)
  }
